var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoardsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36.43 29.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "BoardsIcon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.87,4.72l3.74,1.36V1.22A1.18,1.18,0,0,0,18.87.11L1.74,6.35A2.75,2.75,0,0,0,0,8.73V21.08a1.18,1.18,0,0,0,1.74,1.11l12-4.36v-11a2.15,2.15,0,0,1,2.19-2.27A2.94,2.94,0,0,1,16.87,4.72ZM10.56,16.35,3.71,18.92a1,1,0,0,1-.29,0,.81.81,0,0,1-.77-.53.82.82,0,0,1,.48-1.06L10,14.81a.82.82,0,0,1,1.06.48A.83.83,0,0,1,10.56,16.35Zm0-4.22L3.71,14.7a.77.77,0,0,1-.29.05.82.82,0,0,1-.29-1.58L10,10.59a.82.82,0,0,1,.58,1.54Zm0-4.22L3.71,10.49a1,1,0,0,1-.29,0A.82.82,0,0,1,3.13,9L10,6.38a.82.82,0,1,1,.58,1.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.59,12.22l-14-5.09L16.54,5.65A1.24,1.24,0,0,0,14.7,6.82v13a2.9,2.9,0,0,0,1.84,2.51l18.05,6.57a1.25,1.25,0,0,0,1.84-1.17v-13A2.92,2.92,0,0,0,34.59,12.22ZM22.45,20.73V12.65L29,18.51Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoardsIcon);
export default __webpack_public_path__ + "static/media/BoardsIcon.d2d89ad1fc5083c0d791ad9a7317822d.svg";
export { ForwardRef as ReactComponent };